import { FC } from "react";

interface UploadingImageSVGProps {
    classname?: string;
    fill?: string;
    strokeWidth?: number;
}

const UploadingImageSVG: FC<UploadingImageSVGProps> = (props) => {
    return (
        <svg
            className={props.classname}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 104 84"
            width="100%"
            height="100%"
        >
            <path d="M64.25 1.75H39.25L26.75 16.75H11.75C9.09783 16.75 6.55429 17.8036 4.67893 19.6789C2.80357 21.5543 1.75 24.0978 1.75 26.75V71.75C1.75 74.4022 2.80357 76.9457 4.67893 78.8211C6.55429 80.6964 9.09783 81.75 11.75 81.75H91.75C94.4022 81.75 96.9457 80.6964 98.8211 78.8211C100.696 76.9457 101.75 74.4022 101.75 71.75V26.75C101.75 24.0978 100.696 21.5543 98.8211 19.6789C96.9457 17.8036 94.4022 16.75 91.75 16.75H76.75L64.25 1.75Z" stroke={props.fill} strokeWidth={props.strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M51.75 61.75C60.0343 61.75 66.75 55.0343 66.75 46.75C66.75 38.4657 60.0343 31.75 51.75 31.75C43.4657 31.75 36.75 38.4657 36.75 46.75C36.75 55.0343 43.4657 61.75 51.75 61.75Z" stroke={props.fill} strokeWidth={props.strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
        </svg>

    );
};

export default UploadingImageSVG;
